import styled from "styled-components";
import LeactureNav from "../../../components/lecture-detail/LeactureNav";
import { useLectureDetail } from "../../../hooks/leacture-detail/useLectureDetail";
import { LECTURE_SCENARIO_STEPS } from "../../../constants/lectureScenario";
import LecturePreProblem from "./LecturePreProblem";
import LectureVideo from "./LectureVideo";
import LectureWriting from "./LectureWriting";
import LectureFeedback from "./LectureFeedback";
import LectureReview from "./LectureReview";

export default function LectureDetail() {
  const { 
    selectedNav,
    onNavClickHandler, 
    onNavChangeHandler,
    navList,
    loading,
  } = useLectureDetail();

  const renderContent = () => {
    switch(selectedNav){
      case 1:
        return <LecturePreProblem nav={navList[selectedNav - 1]} onNavChangeHandler={onNavChangeHandler}/>
      case 2:
        return <LectureVideo nav={navList[selectedNav - 1]} onNavChangeHandler={onNavChangeHandler}/> 
      case 3:
        return <LectureWriting nav={navList[selectedNav - 1]} onNavChangeHandler={onNavChangeHandler}/>
      case 4:
        return <LectureFeedback nav={navList[selectedNav - 1]} onNavChangeHandler={onNavChangeHandler}/>
      case 5:
        return <LectureReview nav={navList[selectedNav - 1]} onNavChangeHandler={onNavChangeHandler}/>
      default:
        return null;
    }
  }


  if (loading) {
    return (
      <Container>
        <LeactureNav
          navList={LECTURE_SCENARIO_STEPS.map((s) => ({ ...s }))}
          selectedNav={selectedNav}
          onNavClickHandler={onNavClickHandler}
        />
        <ContentArea>
          <LoadingCard>
            <LoadingSpinner />
            <LoadingText>진행도 로딩 중...</LoadingText>
          </LoadingCard>
        </ContentArea>
      </Container>
    );
  }

  return (
    <Container>
      <LeactureNav navList={navList} selectedNav={selectedNav} onNavClickHandler={onNavClickHandler} />
      <ContentArea>{renderContent()}</ContentArea>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  min-height: 100vh;
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    padding: 20px 16px 40px;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 1024px) {
    width: 100%;
  }
  display: flex;
  flex-direction: column;
  gap: 0;
  /* 태블릿 가로 등: 목차 옆에서 본문 실제 너비 기준으로 자식 레이아웃 전환(@container) */
  container-type: inline-size;
  container-name: lectureDetailContent;
`;

const LoadingCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 360px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top-color: #1d2340;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.span`
  font-size: 0.9375rem;
  color: #64748b;
  font-weight: 500;
`;
